import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "SVG2SVG debug", -1)
const _hoisted_2 = { class: "m-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-item m-2 w-48" }, "Before"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-item m-2 w-48" }, "After")
], -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.svgs, (svg, k) => {
        return (_openBlock(), _createElementBlock("div", {
          key: k,
          class: "flex"
        }, [
          _createElementVNode("img", {
            src: svg.originalImageData,
            class: "flex-item m-2 w-48 border-2"
          }, null, 8, _hoisted_4),
          _createElementVNode("img", {
            src: svg.convedImageData,
            class: "flex-item m-2 w-48 border-2"
          }, null, 8, _hoisted_5)
        ]))
      }), 128))
    ])
  ], 64))
}